import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function BarChartIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M7.5 21.5C7.5 20.6716 8.17157 20 9 20C9.82843 20 10.5 20.6716 10.5 21.5V30.5C10.5 31.3284 9.82843 32 9 32C8.17157 32 7.5 31.3284 7.5 30.5V21.5Z"
        fill="#CCBFFF"
      />
      <path
        d="M13.5 15.5C13.5 14.6716 14.1716 14 15 14C15.8284 14 16.5 14.6716 16.5 15.5V30.5C16.5 31.3284 15.8284 32 15 32C14.1716 32 13.5 31.3284 13.5 30.5V15.5Z"
        fill="#927BF0"
      />
      <path
        d="M19.5 8.5C19.5 7.67157 20.1716 7 21 7C21.8284 7 22.5 7.67157 22.5 8.5V30.5C22.5 31.3284 21.8284 32 21 32C20.1716 32 19.5 31.3284 19.5 30.5V8.5Z"
        fill="#CCBFFF"
      />
      <path
        d="M25.5 15.5C25.5 14.6716 26.1716 14 27 14C27.8284 14 28.5 14.6716 28.5 15.5V30.5C28.5 31.3284 27.8284 32 27 32C26.1716 32 25.5 31.3284 25.5 30.5V15.5Z"
        fill="#927BF0"
      />
    </svg>
  );
};
